import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const HSCodeCategoriesLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-HSCodeCategories' */ './HSCodeCategories'),
  {
    fallback: <LoadingComponent />,
  }
);

const HSCodeCategories = () => <HSCodeCategoriesLoadable />;

export default HSCodeCategories;
